// extracted by mini-css-extract-plugin
module.exports = {"container":"iE2Ve2","textContainer":"_3WRzCM","bottles":"_2Eg3k6","shine-lines":"_2g_Vj_"};